// Self-set away reasons (Nic 2026-10-05). Mirrors server/lib/staffAway.js
// AWAY_REASONS, which validates them; keep the two identical.
export const AWAY_REASONS = ['Break', 'Admin work', 'Personal', 'Other'];

// A self-set away ends by itself after this long.
export const AWAY_MAX_MINUTES = 15;

// Other takes a short note, capped like the drop reasons' Other (the server
// caps it at 40 too).
export const AWAY_NOTE_MAX = 40;
